/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's the weight range that gives a BMI between 18.5 and 24.9 for your height — the range generally considered healthy for adults.`)
};

const es_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es el rango de peso que da un IMC entre 18,5 y 24,9 para tu altura — el rango generalmente considerado saludable para adultos.`)
};

const de_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist der Gewichtsbereich, der einen BMI zwischen 18,5 und 24,9 für Ihre Größe ergibt — der Bereich, der allgemein als gesund für Erwachsene angesehen wird.`)
};

const nl_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is het gewichtsbereik dat een BMI tussen 18,5 en 24,9 voor uw lengte geeft — het bereik dat over het algemeen als gezond voor volwassenen wordt beschouwd.`)
};

const fr_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est la plage de poids qui donne un IMC entre 18,5 et 24,9 pour votre taille — la plage généralement considérée comme saine pour les adultes.`)
};

const it_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È l'intervallo di peso che dà un BMI tra 18,5 e 24,9 per la tua altezza — l'intervallo generalmente considerato sano per gli adulti.`)
};

const pt_br2_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a faixa de peso que dá um BMI entre 18,5 e 24,9 para sua altura — a faixa geralmente considerada saudável para adultos.`)
};

const pt_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o intervalo de peso que dá um IMC entre 18,5 e 24,9 para a sua altura — o intervalo geralmente considerado saudável para adultos.`)
};

const ja_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`それは、あなたの身長のBMIが18.5～24.9の範囲である体重範囲です—一般的に成人にとって健康と見なされる範囲。`)
};

const zh_hw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是指在您的身高下，能使 BMI 落在 18.5 至 24.9 之间的体重范围——该范围通常被认为是成年人的健康范围。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq1_a", locale)
	if (locale === "en") return en_hw_faq1_a(inputs)
	if (locale === "es") return es_hw_faq1_a(inputs)
	if (locale === "de") return de_hw_faq1_a(inputs)
	if (locale === "nl") return nl_hw_faq1_a(inputs)
	if (locale === "fr") return fr_hw_faq1_a(inputs)
	if (locale === "it") return it_hw_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq1_a(inputs)
	if (locale === "pt") return pt_hw_faq1_a(inputs)
	if (locale === "ja") return ja_hw_faq1_a(inputs)
	return zh_hw_faq1_a(inputs)
};